resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function AnimateNumeric () {
  this.id = null;
  this.node = null;
  this.$node = null;
  this.extends = [_ComponentDataBind];
  this.declaredClass = null;

  this.initialized = false;
  this.animated = true;
  this.duration = 1200;
  this.delay = 0;
  this.easing = 'easeOutCubic';
  this.startValue = 0;
  this.value = 0;
  this.float = true;
  this.decimalCount = 2;
  this.display = 'block';

  // overwrite this to styleize output
  this.maskCallback = function (value) {
    return value;
  };
  this.completeCallback = function () {};

  this._delayTimeout = null;

  this.init = function () {
    // Setup the input
    this._super();
    this.$node = $(this.node);

    // set initial value pre animation
    if (this.animated && !isNaN(this.value)) this._displayValue(this.startValue);
    else this._displayValue(this.value);

    // listen to changes to this.value from _ComponentDataBind
    this.onDataBindUpdate('value', this.suspendedAnimation.bind(this));
  };

  this.initAllReady = function () {
    this.initialized = true;
    this.$node.css({display: this.display});

    // animate the value
    this.suspendedAnimation();
  };

  this.destroy = function () {
    this._super();
    if (this._delayTimeout !== null) clearTimeout(this._delayTimeout);
  };

  this.suspendedAnimation = function () {
    // animate the value
    this._delayTimeout = setTimeout(this.animateInteger.bind(this), this.delay);
  };

  this._displayValue = function (value) {
    // update start value so if it updates to a new value post animation it will animate from the current value
    this.startValue = value;

    // if the value should not be a float remove the decimal value
    if (!this.float) value = String(value).split('.')[0];

    // if the string is a float and the decimals have a max count
    if (this.decimalCount && this.float) {
      value = parseFloat(value).toFixed(this.decimalCount);
      value = String(value).split('.');

      if (value.length > 1) {
        value[1] = value[1].substr(0, this.decimalCount);
      }

      value = value.join('.');
    }

    var maskedValue = this.maskCallback(value);
    if (this.$node.html() != maskedValue) {
      this.$node.html(maskedValue);
    }
  };

  this.animateInteger = function () {
    if (!this.initialized) return false;
    if (!this.animated) {
      this._displayValue(this.value);
      return false;
    }

    if (this.value && !isNaN(this.value)) {
      $({value: this.startValue}).animate(
        {value: this.value},
        {
          queue: false,
          easing: this.easing,
          duration: this.duration,

          step: function (value) {
            this._displayValue(value);
          }.bind(this),

          complete: function () {
            this.completeCallback();
          }.bind(this),

          always: function () {
            this._displayValue(this.value);
          }.bind(this)
        }
      );
    } else if (typeof this.value === 'string' && this.$node.html() != this.value) {
      this.$node.html(this.value);
    }
  };
}
